/**
 * Custom element for a countdown timer to a specific date and time.
 * The element will hide itself when the target date is reached.
 */
if (!customElements.get('announcement-timer')) {
  customElements.define(
    'announcement-timer',
    class AnnouncementTimer extends HTMLElement {
      connectedCallback() {
        this.year = parseInt(this.getAttribute('data-year'));
        this.month = parseInt(this.getAttribute('data-month')) - 1; // JS months are 0-11 🤡
        this.day = parseInt(this.getAttribute('data-day'));
        this.hour = parseInt(this.getAttribute('data-hour'));

        // Validate the date attributes
        if (isNaN(this.year) || isNaN(this.month) || isNaN(this.day) || isNaN(this.hour)) {
          console.error('Invalid date attributes provided. Please check the attributes.');
          return;
        }

        // Create a Date object for the target date
        this.targetDate = new Date(this.year, this.month, this.day, this.hour);
        // Get the timer elements
        this.timerElements = {
          days: this.querySelector('[data-days]'),
          hours: this.querySelector('[data-hours]'),
          minutes: this.querySelector('[data-minutes]'),
          seconds: this.querySelector('[data-seconds]'),
        };

        this.startCountdown();
      }

      /**
       * Starts the countdown timer and updates the timer elements every second.
       * Hides the element when the target date is reached.
       * @returns {void}
       */
      startCountdown() {
        this.updateTimer();
        // Update the timer every second
        this.interval = setInterval(() => this.updateTimer(), 1000);
      }

      updateTimer() {
        // Get the current date and time
        const now = new Date();
        // Calculate the time left until the target date
        const timeLeft = this.targetDate - now;

        // If the target date is in the past, clear the interval and hide the element
        if (timeLeft <= 0) {
          clearInterval(this.interval);
          this.style.display = 'none'; // Hide the element
          return;
        }

        // Calculate the days, hours, minutes, and seconds left
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        // Update textual content
        this.timerElements.days.textContent = String(days).padStart(2, '0');
        this.timerElements.hours.textContent = String(hours).padStart(2, '0');
        this.timerElements.minutes.textContent = String(minutes).padStart(2, '0');
        this.timerElements.seconds.textContent = String(seconds).padStart(2, '0');
      }
    }
  );
}
